export const TRADE_SESSION_LIST_PAGE_PATH = '/tradeSession/list'
